<template>
  <div>
    <div class="table-wrapper orders-history">
      <section class="section">
        <div class="section-contents text-justify blog-detail">
          <router-link
            class="float-right btn btn-secondary btn-sm"
            :to="{ name: 'order' }"
          >
            <i class="fa fa-backward"></i> Back
          </router-link>
          <div class="row justify-content-center">
            <div class="col-md-8 text-center">
              <h3>Order Number: {{ orderDetails.order_no }}</h3>
            </div>
          </div>
          <div class="row mt-4 justify-content-center">
            <div class="col-md-4">
              <div class="delivery-box text-center">
                <h5 class="text-muted">Delivery Address</h5>
                <div>
                  {{ orderDetails.shipping_address.first_name }}
                  {{ orderDetails.shipping_address.last_name }},
                  {{ orderDetails.shipping_address.phone }},
                </div>
                <p>
                  {{ orderDetails.shipping_address.address_1 }},
                  {{ orderDetails.shipping_address.city.name }},
                  {{ orderDetails.shipping_address.region.name }}
                </p>
                <br />
                <br />
              </div>
            </div>
            <div class="col-md-4 ml-auto">
              <div class="summary-box text-center">
                <h6 class="text-muted">Order Summary</h6>
                <div class="d-flex justify-content-between">
                  <div>Subtotal</div>
                  <div>
                    <span class="currency">৳</span> {{ orderDetails.sub_total }}
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>Delivery Charge</div>
                  <div>
                    <span class="currency">৳</span>
                    {{ orderDetails.shipping_cost }}
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>Service Chare</div>
                  <div>
                    <span class="currency">৳</span>
                    {{ orderDetails.service_charge }}
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>Discount</div>
                  <div>
                    <span class="currency">৳</span>
                    {{ orderDetails.discount_amount }}
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>Order Total</div>
                  <div>
                    <span class="currency">৳</span>
                    {{ orderDetails.grand_total }}
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div class="text-danger font-weight-bold">Amount Paid</div>
                  <div v-if="orderDetails.payment_status == 'Paid'">
                    <span class="currency">৳</span>
                    {{ orderDetails.grand_total }}
                  </div>
                  <div v-else><span class="currency">৳</span> 0</div>
                </div>
              </div>
              <!-- <div class="due d-flex justify-content-between font-weight-bold">
                            <div>Due</div>
                            <div><span class="currency">৳</span> {{orderDetails.grand_total}}</div>
                        </div> -->
            </div>
          </div>

          <div class="row mt-5 justify-content-center">
            <div class="col-md-12">
              <table class="table table-hover table-bordered">
                <tr>
                  <th>Item</th>
                  <th class="text-right">Rate</th>
                  <th class="text-center">Qty</th>
                  <th class="text-right">Total</th>
                </tr>
                <tr v-for="(row, key) in orderDetails.items" v-bind:key="key">
                  <td>
                      <a
                        :href="`${baseUrl}book/${row.product.id}`"
                        class="btn btn-black view-details"
                        >
                      <div class="d-flex">
                      <img
                      v-if="row.product.image"
                      :src="`${IMAGEURL}${row.product.image}`"
                      class="img-responsive"
                      style="    max-height: 60px;"
                    />
                    <div class="ml-2">  
                        {{ row.product.product_name }}
                         <div class="text-muted font-13">
                      <span v-if="row.product.paper_type">{{ row.product.paper_type }}</span>
                    </div>
                        </div>
                     
                      </div>
                      </a>
                  </td>
                  <td class="text-right">
                    <span class="currency">৳</span> {{ row.price }}
                  </td>
                  <td class="text-center">{{ row.quantity }}</td>
                  <td class="text-right">
                    <span class="currency">৳</span> {{ row.amount }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters } from "vuex";

export default {
  name: "CheckOut",
  components: {},
  computed: {
    ...mapGetters(["cart", "itemsCount", "subTotal"])
  },
  data() {
    return {
      orderDetails: null
    };
  },
  mounted() {
    this.getOrderDetails();
  },
  methods: {
    getOrderDetails() {
      this.$http
        .get("order/" + this.$route.params.id)
        .then(response => {
          this.orderDetails = response.data.order;
          console.log(this.orderDetails);
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
